import { useMutation, useQueryClient } from '@tanstack/react-query';

import { tasksApi } from '../api';
import { MoveTodoTaskBetweenProjectsReq } from '../api/openapi';
import { TEAM_TASKS_QUERY_KEY } from '../queries/teamTasks.shared';

interface UseMoveTodoTaskBetweenProjectsParams extends MoveTodoTaskBetweenProjectsReq {
  userId: string;
}

export function useMoveTodoTaskBetweenProjects() {
  const queryClient = useQueryClient();

  const moveTaskMutation = useMutation({
    mutationFn: ({ userId, ...body }: UseMoveTodoTaskBetweenProjectsParams) => {
      return tasksApi.moveTodoTaskBetweenProjects(userId, body).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_TASKS_QUERY_KEY, type: 'active' });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.overdueTasks'] });
    },
  });

  return {
    moveTodoTaskBetweenProjects: moveTaskMutation.mutateAsync,
    ...moveTaskMutation,
  };
}
